export default {
  'Teklif Formu': 'فرم پیشنهاد',
  'Kayıtlı Teklifler': 'پیشنهادات ذخیره شده',
  'Kullanıcı Adı': 'نام کاربری',
  'Şifre': 'رمز عبور',
  'Giriş Yap': 'ورود',
  'Çıkış Yap': 'خروج',
  'KDV Oranı': 'نرخ مالیات بر ارزش افزوده',
  'Teklif Durumu': 'وضعیت پیشنهاد',
  'Kaydet': 'ذخیره',
  'PDF Önizleme': 'پیش‌نمایش PDF',
  'PDF\'ye Aktar': 'صادر به PDF',
  'E-posta ile Gönder': 'ارسال از طریق ایمیل',
  'Alıcı': 'گیرنده',
  'Tarih': 'تاریخ',
  'Genel Toplam': 'مجموع کل',
  'Not': 'یادداشت',
  'KDV': 'مالیات بر ارزش افزوده',
  'Alt Toplam': 'جمع فرعی',
  'Açıklama': 'توضیحات',
  'Ürün Adı': 'نام محصول',
  'SUT Kodu': 'کد SUT',
  'Birim Alış Fiyatı': 'قیمت واحد',
  'Sipariş Adedi': 'تعداد سفارش',
  'Promosyon Ürün': 'محصول تبلیغاتی',
  'Toplam Adet': 'تعداد کل',
  'Sipariş Tutarı': 'مبلغ سفارش',
  'Durum': 'وضعیت',
  'Kabul Edildi': 'پذیرفته شد',
  'Reddedildi': 'رد شد',
  'Gönderildi': 'ارسال شد',
  'Taslak': 'پیش‌نویس',
  'Yurtiçi': 'داخلی',
  'Yurtdışı': 'بین‌المللی',
  'Sipariş Oluştur': 'ایجاد سفارش',
  'Ürün Sıralaması': 'مرتب‌سازی محصولات',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'محصولات بر اساس محبوبیت و اهمیت مرتب شده‌اند',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'محصولات قلب و عروق و جراحی عروق به عنوان اولویت نمایش داده می‌شوند',
  'Ürün adı, açıklama veya barkod ile ara...': 'جستجو با نام محصول، توضیحات یا بارکد...',
  'Tüm Kategoriler': 'همه دسته‌بندی‌ها',
  'Kutu görünüm': 'نمایش شبکه‌ای',
  'Liste görünüm': 'نمایش لیستی',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'محصولی مطابق با معیارهای جستجوی شما یافت نشد',
  'Ürün Adı Yok': 'بدون نام محصول',
  'Kategori Yok': 'بدون دسته‌بندی',
  'Açıklama yok': 'بدون توضیحات',
  'Firma Bilgilerini Doldurun': 'اطلاعات شرکت را تکمیل کنید',
  'Sepete Ekle': 'افزودن به سبد خرید',
  'Firma Bilgileri': 'اطلاعات شرکت',
  'Ülke Seçimi': 'انتخاب کشور',
  'Türkiye': 'ترکیه',
  'Almanya': 'آلمان',
  'ABD': 'آمریکا',
  'Firma Ünvanı': 'نام شرکت',
  'Vergi Dairesi': 'اداره مالیات',
  'Vergi Numarası': 'شماره مالیاتی',
  'Adres': 'آدرس',
  'Şehir': 'شهر',
  'Yetkili': 'شخص مجاز',
  'Telefon': 'تلفن',
  'Email': 'ایمیل',
  'Bilgileri İlet': 'ارسال اطلاعات',
  'Lütfen eksik alanları doldurun': 'لطفاً فیلدهای خالی را پر کنید',
  'Firma kaydedilemedi': 'شرکت ذخیره نشد',
  'Firma bilgileri başarıyla iletildi': 'اطلاعات شرکت با موفقیت ارسال شد',
  'Firma Ünvanı:': 'نام شرکت:',
  'Yetkili Kişi:': 'شخص مجاز:',
  'Sepetiniz': 'سبد خرید شما',
  'Sepetiniz boş': 'سبد خرید شما خالی است',
  'adet': 'عدد',
  'Düzenle': 'ویرایش',
  'Kaldır': 'حذف',
  'Siparişi Tamamla': 'تکمیل سفارش',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'لطفاً ابتدا اطلاعات کامل شرکت خود را ارسال کنید',
  'Sipariş başarıyla kaydedildi': 'سفارش با موفقیت ذخیره شد',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'پیام خوش‌آمدگویی و لینک دسترسی به ایمیل شما ارسال شد',
  'Link 3 gün geçerlidir': 'لینک به مدت 3 روز معتبر است',
  'Sipariş kaydedilemedi': 'سفارش ذخیره نشد',
  'Firma Bilgileri Gerekli': 'اطلاعات شرکت مورد نیاز است',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'ابتدا اطلاعات شرکت را برای افزودن به سبد خرید پر کنید',
  'Önce Bilgileri Doldurun': 'ابتدا اطلاعات را پر کنید',
  'Uyarı': 'هشدار',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'برای افزودن به سبد خرید ابتدا باید اطلاعات شرکت را پر کنید',
  'SUT Kütüphanesi Tanımı': 'تعریف کتابخانه SUT',
  'SUT Kodu:': 'کد SUT:',
  'Standart': 'استاندارد',
  'Açıklama (isteğe bağlı)': 'توضیحات (اختیاری)',
  'Partner Ol': 'شریک شوید',
  'Partner başvuru popup açılacak': 'پاپ‌آپ درخواست شریک باز خواهد شد',
  'Dil': 'زبان',
  'E-posta': 'ایمیل',
  'Şifre': 'رمز عبور',
  'Şifremi Unuttum': 'رمز عبور را فراموش کرده‌ام',
  'Giriş yapılıyor...': 'در حال ورود...',
  'E-posta veya şifre hatalı': 'ایمیل یا رمز عبور اشتباه است',
  'Şifre sıfırlama e-postası gönderildi': 'ایمیل بازنشانی رمز عبور ارسال شد',
  'E-posta gönderilemedi': 'ایمیل ارسال نشد',
  'Üye Ol': 'ثبت‌نام',
  'Üye Değil Misiniz?': 'عضو نیستید؟',
  'Şimdi Üye Ol': 'اکنون ثبت‌نام کنید',
  'Misafir Kullanıcı': 'کاربر مهمان',
  'Hızlı Sipariş': 'سفارش سریع',
  'Misafir Olarak Sipariş Verin': 'به عنوان مهمان سفارش دهید',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'بدون ورود سریعاً محصولات خود را انتخاب کرده و سفارش خود را ایجاد کنید',
  'Giriş yapmadan sipariş oluşturun': 'بدون ورود سفارش ایجاد کنید',
  'Anında Erişim': 'دسترسی فوری',
  'Tüm ürünlere anında erişim': 'دسترسی فوری به همه محصولات',
  'Güvenli İşlem': 'تراکنش امن',
  'SSL korumalı güvenli sipariş': 'سفارش امن محافظت شده با SSL',
  'Misafir Olarak Sipariş Oluştur': 'به عنوان مهمان سفارش ایجاد کنید',
  'İpucu:': 'نکته:',
  'Daha fazla özellik için üye olun': 'برای ویژگی‌های بیشتر ثبت‌نام کنید',
  'Ücretsiz': 'رایگان',
  'Hızlı': 'سریع',
  'Güvenli': 'امن',
  'bayilikSozlesme': 'من شرایط و ضوابط مشارکت INVAMED را خوانده و پذیرفته‌ام.',
  'geri': 'بازگشت',
  'basvuruGonder': 'ارسال درخواست',
  'ileri': 'بعدی',
  'sozlesmeGonderildi': 'قرارداد به ایمیل شما ارسال شد!',
  'sozlesmeDesc': 'لطفاً قرارداد مشارکت INVAMED و اسناد مورد نیاز ارسال شده به ایمیل شما را در زیر آپلود کنید.',
  'tamamla': 'تکمیل درخواست',
  'basvuruAlindi': 'درخواست شما دریافت شد!',
  'basvuruAlindiDesc': 'تیم INVAMED درخواست شما را بررسی کرده و در اسرع وقت با شما تماس خواهد گرفت.',
  'Başvuru Durumu': 'وضعیت درخواست',
  'Başvurunuz onay sürecindedir': 'درخواست شما در حال بررسی است',
  'sifreSifirla': 'بازنشانی رمز عبور',
  'sifreSifirlaDesc': 'ایمیل ثبت شده خود را وارد کنید و ما دستورالعمل‌های بازنشانی رمز عبور را برای شما ارسال خواهیم کرد.',
  'gonder': 'ارسال',
  'talimatGonderildi': 'دستورالعمل‌ها ارسال شد',
  'sentDesc': 'دستورالعمل‌های بازنشانی رمز عبور به <b>{email}</b> ارسال شد. لطفاً ایمیل خود را بررسی کنید.',
  'helpTitle': 'چگونه می‌توانم وارد شوم؟',
  'helpList': [
    'برای ورود به پنل توزیع‌کننده INVAMED، ایمیل ثبت شده و رمز عبور خود را وارد کنید.',
    'برای ورود با کاربر آزمایشی:',
    'اگر رمز عبور خود را فراموش کرده‌اید، از لینک "رمز عبور را فراموش کرده‌ام" برای درخواست بازنشانی استفاده کنید.',
    'اگر در ورود مشکل دارید، مطمئن شوید که ایمیل و رمز عبور شما صحیح است. اگر مشکل ادامه دارد، با تیم پشتیبانی ما تماس بگیرید.'
  ],
  'partnerlikSozlesmeTitle': 'قرارداد مشارکت INVAMED و شرایط',
  'partnerlikSozlesmeText': `1. مقررات عمومی

این قرارداد بین INVAMED (از این پس "شرکت" نامیده می‌شود) و نامزد شریک (از این پس "شریک" نامیده می‌شود) برای همکاری در فروش دستگاه‌ها و تجهیزات پزشکی منعقد می‌شود.

2. شرایط مشارکت

2.1. شریک باید اختیار قانونی برای فروش دستگاه‌های پزشکی داشته باشد.
2.2. شریک باید سازمانی باشد که در بخش مراقبت‌های بهداشتی فعالیت می‌کند.
2.3. شریک باید مجوزها و گواهینامه‌های لازم را داشته باشد.
2.4. شریک باید از نظر مالی قابل اعتماد باشد.

3. تعهدات طرفین

تعهدات شرکت:
3.1. ارائه محصولات و خدمات با کیفیت
3.2. ارائه پشتیبانی فنی
3.3. ارائه آموزش و اطلاعات
3.4. شفافیت در قیمت‌گذاری

تعهدات شریک:
3.1. نگهداری محصولات در شرایط مناسب
3.2. ارائه خدمات مشتری با کیفیت
3.3. رعایت مقررات قانونی
3.4. محافظت از برند شرکت

4. قیمت‌گذاری و پرداخت

4.1. قیمت‌ها توسط شرکت تعیین می‌شود
4.2. شریک موظف به حفظ قیمت‌های تعیین شده است
4.3. شرایط پرداخت جداگانه تعیین می‌شود
4.4. نرخ‌های کمیسیون ممکن است بر اساس عملکرد متفاوت باشد

5. محرمانگی و امنیت

5.1. طرفین موظف به محافظت از اطلاعات محرمانه یکدیگر هستند
5.2. اطلاعات مشتریان باید محرمانه نگهداری شود
5.3. استانداردهای امنیت داده باید رعایت شود

6. مدت و فسخ قرارداد

6.1. این قرارداد به مدت 1 سال معتبر است
6.2. ممکن است با توافق متقابل تمدید شود
6.3. ممکن است با اخطار 30 روزه فسخ شود
6.4. در صورت نقض جدی ممکن است فوراً فسخ شود

7. حل اختلافات

7.1. اختلافات عمدتاً از طریق مذاکره حل می‌شود
7.2. دادگاه‌های جمهوری ترکیه برای موارد حل نشده صلاحیت دارند

8. اعتبار

این قرارداد توسط طرفین خوانده، درک و پذیرفته شده است.`,
  'partnerlikSozlesmeOnay': 'من قرارداد مشارکت INVAMED و شرایط فوق را خوانده، درک کرده و پذیرفته‌ام. اعلام می‌کنم که تمام مواد این قرارداد را پذیرفته و تعهدات خود را انجام خواهم داد.',
  'sozlesmeyiGoruntule': 'مشاهده قرارداد',
  'sozlesmeyiKapat': 'بستن',
  'Ürün': 'محصول',
  'Ürün eklemek için ürün listesinden seçim yapın': 'از لیست محصولات برای افزودن به سبد خرید انتخاب کنید',
  'Etiketler': 'برچسب‌ها',
  'Öncelikli': 'اولویت',
  'Kapat': 'بستن',
  'globalPartnersTitle': 'همکاری با 30,000 شریک در سراسر جهان',
  'globalPartnersDesc': 'شبکه گسترده جهانی ما با 30,000 شریک، نوآوری مشترک، تبادل دانش و موفقیت متقابل را تقویت می‌کند. با کار کردن با هم، ما به طور مداوم مرزهای مراقبت از بیماران را گسترش می‌دهیم.',
  'Yardım': 'راهنما',
  'dil': 'زبان',
  'Connect Free!': 'رایگان متصل شوید!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'محصولات محبوب ما را کشف کنید',
  'Tüm Kategoriler': 'همه دسته‌بندی‌ها',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 محصول نمایش داده شده (مجموع: 8000+)',
  'Tüm Ürünleri Gör →': 'مشاهده همه محصولات →',
  'Detaylar': 'جزئیات',
  'Sipariş Ver': 'اکنون سفارش دهید',
  'Giriş Yap': 'ورود',
  'Hesabınıza giriş yapın': 'به حساب کاربری خود وارد شوید',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'این سایت توسط reCAPTCHA محافظت می‌شود و سیاست حفظ حریم خصوصی و شرایط خدمات Google اعمال می‌شود.',
  'Ürün Kataloğumuz': 'کاتالوگ محصولات ما',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'ما بیش از 8000 محصول ارائه می‌دهیم',
  '1,3B': '1.3هزار',
  'Partner': 'شریک',
  '8,4M': '8.4میلیون',
  'Toplam Üretim': 'تولید کل',
  '23': '23',
  'Branş': 'شعبه',
  '27,5B': '27.5هزار',
  'Toplam Sipariş': 'سفارشات کل',
  'Connect Now': 'اکنون متصل شوید',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'برای دسترسی به تمام اطلاعات در یک مکان رایگان ثبت‌نام کنید.',
  'Ürün Detayları': 'جزئیات محصول',
  'Kapat': 'بستن',
  'Yükleniyor...': 'در حال بارگذاری...',
  'Hata': 'خطا',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} محصول نمایش داده شده (مجموع: 8000+)',
  'Şehir Seçimi': 'انتخاب شهر',
  'Firma / Sağlık Profesyoneli': 'شرکت / متخصص بهداشت',
  'Yetkili Kişi': 'شخص مجاز',
  'Telefon': 'تلفن',
  'E-posta': 'ایمیل',
  'Temel Bilgiler': 'اطلاعات پایه',
  'Ek Bilgiler': 'اطلاعات اضافی',
  'Faaliyet Alanı / Sektör': 'حوزه فعالیت / بخش',
  'Ülke Seçimi': 'انتخاب کشور',
  'Ülke adı veya kodu ara...': 'جستجوی نام یا کد کشور...',
  'region.Avrupa': 'اروپا',
  'region.Amerika': 'آمریکا',
  'region.Asya': 'آسیا',
  'region.Afrika': 'آفریقا',
  'region.Okyanusya': 'اقیانوسیه',
  'region.Diğer': 'سایر',
  'country.TR': 'ترکیه',
  'country.US': 'ایالات متحده',
  'country.DE': 'آلمان',
  'country.FR': 'فرانسه',
  'country.GB': 'بریتانیا',
  'country.IT': 'ایتالیا',
  'country.ES': 'اسپانیا',
  'country.RU': 'روسیه',
  'country.CN': 'چین',
  'country.JP': 'ژاپن',
  'country.KR': 'کره جنوبی',
  'country.IN': 'هند',
  'country.BR': 'برزیل',
  'country.CA': 'کانادا',
  'country.AU': 'استرالیا',
  'Ticaret Sicil No': 'شماره ثبت تجاری',
};
